import { render, staticRenderFns } from "./TripRevenue.vue?vue&type=template&id=0f46f85f&scoped=true"
import script from "./TripRevenue.vue?vue&type=script&lang=js"
export * from "./TripRevenue.vue?vue&type=script&lang=js"
import style0 from "./TripRevenue.vue?vue&type=style&index=0&id=0f46f85f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f46f85f",
  null
  
)

export default component.exports